var map = {
	"./testimage1.jpg": "DoDk",
	"./testimage10.jpg": "aGi8",
	"./testimage2.jpg": "ZrTA",
	"./testimage3.jpg": "1GWz",
	"./testimage4.jpg": "R7+w",
	"./testimage5.jpg": "HFSL",
	"./testimage6.jpg": "tcMY",
	"./testimage7.jpg": "G7Q4",
	"./testimage8.jpg": "v7YM",
	"./testimage9.jpg": "V5Pa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f6VH";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news ^\.\/.*$
// module id = f6VH
// module chunks = 0